export default __webpack_public_path__ + "static/media/cotentin.9fff96c6.svg";